<template>
    <div style="min-height: 85vh; height: 100vh;">
        <iframe v-if="iframe_info.url" :src="iframe_info.url" width="100%" height="100%" frameborder="0"></iframe>
        <div v-else>
            <h3 class="pa-2">{{ "Please try again" | t }}</h3>
            <v-snackbar color="error" bottom :timeout="2500" value="ERROR">
                <div style="display: flex">
                    <v-icon color="#FFF">error</v-icon>
                    <div class="title pa-2 ">{{ "Something went wrong." | t }}</div>
                </div>
            </v-snackbar>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "iframe-page-view",
    computed: {
        ...mapState(["iframe_info"])
    },
    mounted() {}
};
</script>

<style scoped>
iframe {
    min-width: 100vw;
}
</style>
